<div class="accordion-tab" [class.disabled]="disabled" [class.open]="active">
  <div class="accordion-header w-full flex justify-between items-center px-2 py-2 cursor-pointer border-b"
    (click)="toggleSelf()">
    <div class="flex-1">
      @if (headerTemplate) {
        <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
      } @else {
        <span class="text-base font-medium">{{ header }}</span>
      }
    </div>

    @if (!disabled) {
      <span class="accordion-icon ml-4">
        <i [ngClass]="['icon', active ? collapseIcon : expandIcon]"></i>
      </span>
    }
  </div>

  <div class="accordion-content" [class.expanded]="active" [attr.inert]="active ? null : ''">
    <div class="accordion-content-inner">
      <div class="accordion-content-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
